import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { ARENA_COPY } from "@/lib/arena-copy";
import { useArenaMe, useArenaWindow } from "@/lib/arena";

/** Плитка ARENA на главной: в окне присоединения (ARENA_JOIN_FROM–ARENA_JOIN_UNTIL), после главного напоминания (не вытесняет его). */
export function ArenaHomeTile() {
  const open = useArenaWindow();
  const { data: me, isLoading } = useArenaMe();
  if (!open || isLoading) return null;
  const participant = !!me && (me.days ?? []).length > 0;
  return (
    <Link
      to={participant ? "/arena/people" : "/arena"}
      className="flex min-w-0 items-center gap-3 rounded-2xl border border-td-orange/30 bg-gradient-to-r from-td-orange/15 to-td-teal/10 p-4"
    >
      <span className="flex size-11 shrink-0 items-center justify-center rounded-full bg-white text-xl">
        🎪
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-base font-semibold text-td-dark">{ARENA_COPY.homeTile}</span>
        <span className="block text-sm text-td-muted">{ARENA_COPY.homeTileNote}</span>
      </span>
      <ChevronRight className="size-5 shrink-0 text-td-muted" />
    </Link>
  );
}

/** Пункт меню ARENA — только участникам и только в окне фестиваля. */
export function useArenaNavVisible(): boolean {
  const open = useArenaWindow();
  const { data: me } = useArenaMe();
  return open && !!me && (me.days ?? []).length > 0;
}
